// ============================================================================

// src/services/weatherRouteApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { 
  OMNISTACK_BASE_URL, 
  getPrepareHeaders 
} from '@/hooks/common/common-functions'

export const weatherRouteApi = createApi({
  reducerPath: 'weatherRouteApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${OMNISTACK_BASE_URL}business/weather-routes`,
    prepareHeaders: (headers) => {
      getPrepareHeaders({
        headers,
        isClientApiKey: true,
      });
      
      const businessApiKey = localStorage.getItem('businessApiKey');
      if (businessApiKey) {
        headers.set('business-x-api-key', businessApiKey);
      }
      
      return headers;
    },
  }),
  tagTypes: ['WeatherData', 'WeatherAlerts', 'WeatherImpact'],
  endpoints: (builder) => ({
    // Get weather impact
    getWeatherImpact: builder.query({
      query: ({ businessId, lat, lng, date }) => ({
        url: '/weather-impact',
        params: { businessId, lat, lng, date }
      }),
      providesTags: ['WeatherImpact']
    }),

    // Adjust route for weather
    adjustRouteForWeather: builder.mutation({
      query: ({ businessId, ...routeData }) => ({
        url: '/adjust-route',
        method: 'POST',
        params: { businessId },
        body: routeData
      }),
      invalidatesTags: ['WeatherImpact']
    }),

    // Get weather alerts
    getWeatherAlerts: builder.query({
      query: ({ businessId, severity, alertType }) => ({
        url: '/alerts',
        params: { businessId, severity, alertType }
      }),
      providesTags: ['WeatherAlerts']
    }),

    // Update weather data
    updateWeatherData: builder.mutation({
      query: ({ businessId }) => ({
        url: '/update-weather-data',
        method: 'PUT',
        params: { businessId }
      }),
      invalidatesTags: ['WeatherData', 'WeatherAlerts', 'WeatherImpact']
    }),
  })
});

export const {
  useGetWeatherImpactQuery,
  useAdjustRouteForWeatherMutation,
  useGetWeatherAlertsQuery,
  useUpdateWeatherDataMutation,
} = weatherRouteApi;